import React, { useState, useEffect} from 'react'
import { Row, Col, Input, Button, Select, Tooltip, message, Spin, Tabs, Table, Pagination } from 'antd'
import styles from './salesstatisticsreport.module.less'
import moment from 'moment'
import DateChoose from '@/compenents/dateChoose'
import {getParmUrl, getCookieNew, outformat, numFormat} from '@/public/utils'
import { ajaxApi, fileDownloadApiToken, axiosPost } from '../../../server'
import {QuestionCircleOutlined} from '@ant-design/icons'
import common from '@/public/common'
import { get,cloneDeep, set } from 'lodash'
import qs from 'querystring'
const {Option} = Select
const { TabPane } = Tabs
const SalesStatisticSreport = () => {
  const [loading, setLoading] = useState(false)
  const [brandArr, setBrandArr] = useState([])
  const [categoryArr, setCategoryArr] = useState([])
  const [param, setParam] = useState({
    name_code: getParmUrl('nameCode') || '',
    sid: JSON.parse(getCookieNew('supplierinfo')).sid,
    // sid: 762,
    user_id: JSON.parse(getCookieNew('adminName')).UserID,
    brand_id: getParmUrl('brand_id') ? getParmUrl('brand_id') * 1 : null,
    category: getParmUrl('category') ? getParmUrl('category') * 1 : null,
    // is_stop_procure: 1,
    display_zero_sales: 0,
    start_date: getParmUrl('jumpdata') ? getParmUrl('jumpdata') : moment(moment().startOf('day').subtract(30, 'days')).format('YYYY-MM-DD'),
    end_date: getParmUrl('jumpdata') ? getParmUrl('jumpdata') : moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD'),
    page_index: 1,
    page_size: 10
  })

  const [saleDefaultValue, setSaleDefaultValue] = useState(getParmUrl('jumpdata') ? [moment(getParmUrl('jumpdata')).valueOf(), moment(getParmUrl('jumpdata')).valueOf()] : 'thirty_days')
  const [activeKey, setActiveKey] = useState(getParmUrl('particle') || 'item')
  const [tableData, setTableData] = useState([])
  const [total, setTotal] = useState(0)
  const [totalSaleNum, setTotalSaleNum] = useState(0)
  const [exportBtnLoading, setExportBtnLoading] = useState(false)

  const stopMining = [
    {name: '是', value: 2}, {name: '否', value: 3}
  ]

  const zeroSales = [
    {name: '有库存', value: 1}, {name: '无库存', value: 0}
  ]

  const [columnsProduct, setColumnsPcoduct] = useState(
    [
      {
        title: '货品',
        dataIndex: 'product_name',
        render: (_, record) => <span>{record.product_name || '--'}</span>
      },
      {
        title: '类别',
        dataIndex: 'category',
        render: (_, record) => <span>{record.category || '--'}</span>
      },
      {
        title: '编码',
        dataIndex: 'product_code',
        render: (_, record) => <span>{record.product_code || '--'}</span>
      },
      {
        title: '品牌',
        dataIndex: 'brand_name',
        render: (_, record) => <span>{record.brand_name || '--'}</span>
      },
      {
        title: '销量（件数）',
        dataIndex: 'sale_num',
        render: (_, record) => <span>{record.sale_num || record.sale_num === 0 ? outformat(record.sale_num) : '--'}</span>
      }
    ]
  )

  const [columnsItem, setColumnsItem] = useState([
    {
      title: '商品',
      dataIndex: 'item_name',
      render: (_, record) => <span>{record.item_name || '--'}</span>
    },
    {
      title: '类别',
      dataIndex: 'category',
      render: (_, record) => <span>{record.category || '--'}</span>
    },
    {
      title: '编码',
      dataIndex: 'item_code',
      render: (_, record) => <span>{record.item_code || '--'}</span>
    },
    {
      title: '品牌',
      dataIndex: 'brand_name',
      render: (_, record) => <span>{record.brand_name || '--'}</span>
    },
    {
      title: '销量（件数）',
      dataIndex: 'sale_num',
      render: (_, record) => <span>{record.sale_num || record.sale_num === 0 ? outformat(record.sale_num) : '--'}</span>
    }
  ])

  useEffect(() => {
    if (getParmUrl('particle') === 'product') {
      getProductData()
      // const columnsClone = (lodash.clone(columns))
      // columnsClone.shift()
      // columnsClone.unshift({
      //   title: '商品',
      //   dataIndex: 'item_name',
      //   render: (_, record) => <span>{record.item_name || '--'}</span>
      // })
      // setColumns(columnsClone)
    } else {
      getItemData()
    }
    getPageJurisdictionCode()
    getBrand()
    getCategory()
  }, [])

  // 获取货品的值
  const getProductData = async (value) => {
    var params = value || param
    if (checkEndDateIsToday(params)) {
      return
    }
    setLoading(true)
    const res = await ajaxApi({
      params,
      url: common.SapUrl + 'saleStat/queryProduct'
    })
    setLoading(false)
    if (res.status === 200 && res.data) {
      if (res.data.sale_list.length !== 0) {
        res.data.sale_list.forEach((item, index) => {
          item.key = index
        })
        setTableData(res.data.sale_list)
      } else {
        setTableData([])
      }
      setTotal(res.data.total_count)
      setTotalSaleNum(res.data.total_sale_num)
    } else {
      setTotal(0)
      setTotalSaleNum(0)
      setTableData([])
    }
  }

  const checkEndDateIsToday=(params)=>{
    var startOverflag = get(params, 'start_date') && (moment().subtract(1, 'days').endOf('day').valueOf() < moment(get(params, 'start_date')).valueOf())
    var endOverflag = get(params, 'end_date') && (moment().subtract(1, 'days').endOf('day').valueOf() < moment(get(params, 'end_date')).valueOf())
    if(startOverflag||endOverflag){
      message.error('不支持查询今天及之后的数据，请重新选择统计期间！')
    }
    return startOverflag||endOverflag
  }

  // 获取商品的值
  const getItemData = async (value) => {
    var params = value || param
    if (checkEndDateIsToday(params)) {
      return
    }
    setLoading(true)
    try{
      const res = await ajaxApi({
        params,
        url: common.SapUrl + 'saleStat/queryItem'
      })
      setLoading(false)
      if (res.status === 200 && res.data) {
        if (res.data.sale_list.length !== 0) {
          res.data.sale_list.forEach((item, index) => {
            item.key = index
          })
          setTableData(res.data.sale_list)
        } else {
          setTableData([])
        }
        setTotal(res.data.total_count)
        setTotalSaleNum(res.data.total_sale_num)
      } else {
        setTotal(0)
        setTotalSaleNum(0)
        setTableData([])
      }
    }catch(err){
      setLoading(false)
    }
  }

  const getBrand = async () => {
    const res = await ajaxApi({
      params: qs.stringify({ sid: JSON.parse(getCookieNew('supplierinfo')).sid }),
      url: common.SapUrl+'saleStat/query-brands',
      ContentType: 'application/x-www-form-urlencoded'
    })
    if (res.status === 200 && res.data.brand_list.length !== 0) {
      setBrandArr(res.data.brand_list)
    }
  }

  // 获取类别
  const getCategory = async () => {
    const res = await ajaxApi({
      params: qs.stringify({ sid: JSON.parse(getCookieNew('supplierinfo')).sid }),
      url: common.SapUrl + 'base/queryCategory',
      ContentType: 'application/x-www-form-urlencoded'
    })
    if (res.status === 200 && res.data.category_list.length !== 0) {
      setCategoryArr(res.data.category_list)
    }
  }

  // 获取统计日期
  const SalesTime = (dataStr) => {
    let paramNew = cloneDeep(param)
    if (dataStr.length !== 0) {
      setParam({...param, start_date: moment(dataStr[0]).format('YYYY-MM-DD'), end_date: moment(dataStr[1]).format('YYYY-MM-DD'), page_index: 1})
      paramNew.start_date = moment(dataStr[0]).format('YYYY-MM-DD')
      paramNew.end_date = moment(dataStr[1]).format('YYYY-MM-DD')
    } else {
      setParam({...param, start_date: '', end_date: '', page_no: 1})
      paramNew.start_date = ''
      paramNew.end_date = ''
    }
    if (activeKey === 'item') {
      getItemData(paramNew)
    } else {
      getProductData(paramNew)
    }
  }

  // 查询
  const handleSearch = () => {
    let paramNew = cloneDeep(param)
    setParam({...param, page_index: 1})
    paramNew.page_index = 1
    if (activeKey === 'item') {
      getItemData(paramNew)
    } else {
      getProductData(paramNew)
    }
  }

  // 重置
  const handleReast = () => {
    var start_date = moment(moment().startOf('day').subtract(30, 'days')).format('YYYY-MM-DD')
    var end_date = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD')
    let paramNew = cloneDeep(param)
    paramNew.name_code = ''
    paramNew.brand_id = null
    paramNew.category = null
    // paramNew.is_stop_procure = 1
    paramNew.display_zero_sales = null
    paramNew.start_date = start_date
    paramNew.end_date = end_date
    paramNew.page_index = 1
    paramNew.page_size = 10
    setParam({...param, name_code: '', brand_id: '', category: '', display_zero_sales: null, start_date: start_date, end_date: end_date, page_index: 1, page_size: 10})
    setSaleDefaultValue([moment(start_date).valueOf(), moment(end_date).valueOf()])
    if (activeKey === 'product') {
      getProductData(paramNew)
    } else {
      getItemData(paramNew)
    }
  }

  // 导出
  const handleExport = async () => {
    setExportBtnLoading(true)
    const nowTime = moment().format('YYYYMMDDHHmmss')
    const name = activeKey === 'product' ? '货品销量统计' : '商品商品销量统计'
    var exportParams = cloneDeep(param)
    set(exportParams,'particle',activeKey)
    const res = await fileDownloadApiToken({
      param: exportParams,
      url: common.SapUrl + 'saleStat/export',
      // url: 'http://192.168.10.67:8120/saleStat/export',
      filename: name + nowTime + '.xls'
    })
    setExportBtnLoading(false)
  }

  // 跳页数
  const onShowSizeChange = (current, pageSize) => {
    // pageSize
    if (activeKey === 'product') {
      getProductData({ ...param, page_index: current, page_size: pageSize })
    } else {
      getItemData({ ...param, page_index: current, page_size: pageSize })
    }
    setParam({...param, page_index: current, page_size: pageSize})
  }

  // 分页
  const pageChage = (page, size) => {
    if (activeKey === 'product') {
      getProductData({...param, page_index: page, page_size: size})
    } else {
      getItemData({...param, page_index: page, page_size: size})
    }
    setParam({...param, page_index: page, page_size: size})
  }

  // tab切换
  const callback = (key) => {
    setActiveKey(key)
    if (key === 'item') {
      getItemData({...param, page_index: 1, page_size: 10})
    } else {
      getProductData({...param, page_index: 1, page_size: 10})
    }
    setParam({...param,page_index: 1, page_size: 10})
    getPageJurisdictionCode(key)
  }

  const cuolumnsPro = [
    {
      title: '货品',
      dataIndex: 'product_name',
      render: (_, record) => <span>{record.product_name || '--'}</span>
    },
    {
      title: '类别',
      dataIndex: 'category',
      render: (_, record) => <span>{record.category || '--'}</span>
    },
    {
      title: '编码',
      dataIndex: 'product_code',
      render: (_, record) => <span>{record.product_code || '--'}</span>
    },
    {
      title: '品牌',
      dataIndex: 'brand_name',
      render: (_, record) => <span>{record.brand_name || '--'}</span>
    },
    {
      title: '销量（件数）',
      dataIndex: 'sale_num',
      render: (_, record) => <span>{record.sale_num || record.sale_num === 0 ? outformat(record.sale_num) : '--'}</span>
    }
  ]

  const columnsIte = [
    {
      title: '商品',
      dataIndex: 'item_name',
      render: (_, record) => <span>{record.item_name || '--'}</span>
    },
    {
      title: '类别',
      dataIndex: 'category',
      render: (_, record) => <span>{record.category || '--'}</span>
    },
    {
      title: '编码',
      dataIndex: 'item_code',
      render: (_, record) => <span>{record.item_code || '--'}</span>
    },
    {
      title: '品牌',
      dataIndex: 'brand_name',
      render: (_, record) => <span>{record.brand_name || '--'}</span>
    },
    {
      title: '销量（件数）',
      dataIndex: 'sale_num',
      render: (_, record) => <span>{record.sale_num || record.sale_num === 0 ? outformat(record.sale_num) : '--'}</span>
    }
  ]

  // 获取页面的权限code
  const getPageJurisdictionCode = async (key) => {
    const paramData = {
      url: window.location.pathname,
      accountId: getCookieNew("accountId") ? parseInt(getCookieNew("accountId")) : null,
      roleType: "system_and_supplier",
      supplierCode: getCookieNew("supplier_code") || "",
      poSubjectCode: getCookieNew("po_subject_code") || "",
      supplierCompanyCode: getCookieNew("supplier_company_code") || ""
    }
    const res = await axiosPost(common.eurekaUrlDic + '/permission/query-edit-code', paramData)
    if (res.status === 200) {
      const columnsNew = []
      let codeList = res.data
      if (codeList.length !== 0) {
        if (codeList.includes('20210705100100002')) {
          columnsNew.push({
            title: '可用库存',
            dataIndex: 'available_qty',
            render: (_, record) => <span>{record.available_qty || record.available_qty === 0 ? outformat(record.available_qty) : '--'}</span>
          })
        }
        if (codeList.includes('20210705100100003')) {
          columnsNew.push({
            title: <span>
              <span>预计可售天数</span>
              <Tooltip title="可用库存/统计期间日均销量（全渠道）"> <QuestionCircleOutlined /></Tooltip>
            </span>,
            dataIndex: 'pre_sale_days',
            render: (_, record) => <span>{record.pre_sale_days || record.pre_sale_days === 0 ? outformat(record.pre_sale_days) : (record.pre_sale_days === -1 ? '∞' : '--')}</span>
          })
        }
        if (codeList.includes('20210705100100004')) {
          columnsNew.push({
            title: '销售平台',
            dataIndex: 'sale_store_name',
            render: (_, record) => <span>{record.sale_store_name || '--'}</span>
          })
        }
        if (codeList.includes('20210705100100005')) {
          columnsNew.push({
            title: '店铺',
            dataIndex: 'source_channel_name',
            render: (_, record) => <span>{record.source_channel_name || '--'}</span>
          })
        }
        if (codeList.includes('20210705100100006')) {
          columnsNew.push({
            title: '销售金额',
            dataIndex: 'sale_price',
            render: (_, record) => <span>{record.sale_price || record.sale_price === 0 ? numFormat(record.sale_price, 2) : '--'}</span>
          })
        }
        if (key) {
          if (key === 'product') {
            const cuolumnsProNew = cuolumnsPro.concat(columnsNew)
            setColumnsPcoduct(cuolumnsProNew)
          } else {
            const columnsIteNew = columnsIte.concat(columnsNew)
            setColumnsItem(columnsIteNew)
          }
        } else {
          if (activeKey === 'product') {
            const cuolumnsProNew = cuolumnsPro.concat(columnsNew)
            setColumnsPcoduct(cuolumnsProNew)
          } else {
            const columnsIteNew = columnsIte.concat(columnsNew)
            setColumnsItem(columnsIteNew)
          }
        }
      }
    }
  }

  return (
    <Spin spinning={loading}>
      <div className="goodIn">
        <div className="search">
          <Row gutter={24}>
            <Col span={6}>
              <span className={styles.publicspan}>名称/编码：</span>
              <Input placeholder='请输入' allowClear={true} name='name_code' value={param.name_code} onChange={(e) => { setParam({...param, name_code: e.target.value}) }} style={{ width: '70%', marginRight: '0px' }} />
            </Col>

            <Col span={6}>
              <span className={styles.publicspan}>商品品牌：</span>
              <Select
                showSearch
                // mode="multiple"
                // allowClear={true}
                style={{ width: '70%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={param.brand_id}
                onChange={(e) => { setParam({...param, brand_id: e}) }}
              >
                <Option key={0} name='brand_id' value=''>请选择</Option>
                {brandArr || brandArr.length === 0 ? brandArr.map((item, index) => (
                  <Option key={item.brand_id} name='brand_id' value={item.brand_id}>{item.brand_name}</Option>
                )) : null}
              </Select>
            </Col>

            <Col span={6}>
              <span className={styles.publicspan}>商品类别：</span>
              <Select
                showSearch
                // mode="multiple"
                // allowClear={true}
                style={{ width: '70%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={param.category}
                onChange={(e) => { setParam({...param, category: e}) }}
              >
                <Option key={0} name='category' value=''>请选择</Option>
                {(categoryArr || categoryArr.length === 0) ? categoryArr.map((item, index) => (
                  <Option key={item.category_id} name='category' value={item.category_id}>{item.category_name}</Option>
                )) : null}
              </Select>
            </Col>

            <Col span={6}>
              <Button type='primary' onClick={handleSearch} shape="round">查询</Button>
              {/* <Button style={{margin: '0px 8px'}} type='' onClick={handleReast} shape="round">重置</Button> */}
              <Button style={{margin: '0px 8px'}} type='' onClick={()=>{window.location.reload()}} shape="round">重置</Button>
              <Button type='primary' onClick={handleExport} loading={exportBtnLoading} shape="round">导出</Button>
            </Col>
          </Row>

          <Row gutter={24} style={{marginTop: '16px'}}>
            {/* <Col span={6}>
              <span className={styles.publicspan}>停采：</span>
              <Select
                showSearch
                // mode="multiple"
                // allowClear={true}
                style={{ width: '70%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={param.is_stop_procure}
                onChange={(e) => { setParam({...param, is_stop_procure: e}) }}
              >
                <Option key={0} name='is_stop_procure' value={1}>请选择</Option>
                {(stopMining || stopMining.length === 0) ? stopMining.map((item, index) => (
                  <Option key={index + 1} name='is_stop_procure' value={item.value}>{item.name}</Option>
                )) : null}
              </Select>
            </Col> */}

            <Col span={6}>
              <span className={styles.publicspan}>是否有库存：</span>
              <Select
                showSearch
                // mode="multiple"
                style={{ width: '70%', marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={param.have_any_inventory}
                onChange={(e) => { setParam({...param, have_any_inventory: e}) }}
              >
                {(zeroSales || zeroSales.length === 0) ? zeroSales.map((item, index) => (
                  <Option key={index + 1} name='display_zero_sales' value={item.value}>{item.name}</Option>
                )) : null}
              </Select>
            </Col>

            <Col span={12}>
              <span className={styles.publicspan}>统计日期：</span>
              <DateChoose
                defaultValue={saleDefaultValue}
                ifConvenient={true}
                isStatus={true}
                isClick={false}
                ifshowClear={true}
                timerChange={SalesTime}
                endNotBeToday={true}
                time = {true}/>
            </Col>
          </Row>
        </div>
        <div className="goodBody">
          <Tabs activeKey={activeKey} onChange={callback} type="card">
            <TabPane tab="货品" key="product">
              <div style={{margin: '8px'}}>销量总计件数：<span style={{color: 'red'}}>{totalSaleNum ? outformat(totalSaleNum) : '--'}</span></div>
              <Table
                bordered={false}
                rowKey={record => record.key}
                dataSource={tableData}
                pagination={false}
                columns={columnsProduct}
              >
              </Table>
            </TabPane>

            <TabPane tab="商品" key="item">
              <div style={{margin: '8px'}}>销量总计件数：<span style={{color: 'red'}}>{totalSaleNum ? outformat(totalSaleNum) : '--'}</span></div>
              <Table
                bordered={false}
                rowKey={record => record.key}
                dataSource={tableData}
                pagination={false}
                columns={columnsItem}
              >
              </Table>
            </TabPane>
          </Tabs>
          <div className={styles.page}>
            <span style={{position: 'absolute', left: '2px', top: '-4px', fontSize: '14px'}}><span>共</span><span>{total}</span><span>条记录</span></span>
            <Pagination current={param.page_index} showQuickJumper total={total} pageSize = {param.page_size} showSizeChanger onShowSizeChange={onShowSizeChange} onChange={pageChage}/>
          </div>
        </div>
      </div>
    </Spin>
  )
}
export default SalesStatisticSreport



// WEBPACK FOOTER //
// ./src/pages/salesreport/salesstatisticsreport/salesstatisticsreport.js